import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18n';

import {
  setActivityModalLibraryDropdownSearchInput,
  setActivityModalLibraryDropdownTemplatesToDisplay,
} from 'Actions/activityModal';

import sortByKey from '../../sortByKey';

import TemplateItem from './TemplateItem';
import FormField from '../../FormField';

const i18nOpts = { scope: 'activity_modal.form_fields.templates' };

const renderMainContent = (templatesToDisplay) => {
  if (templatesToDisplay?.length > 0) {
    const sortedTemplates = sortByKey(templatesToDisplay, 'name');
    const templates = sortedTemplates.map((template, id) => {
      return <TemplateItem key={`template-${id}`} template={template} />;
    });
    return <ul className="library_dropdown__templates_list">{templates}</ul>;
  } else {
    return <div className="library_dropdown__no_templates">{t('no_templates', i18nOpts)}</div>;
  }
};

export const handleTemplatesSearch = (
  setActivityModalLibraryDropdownSearchInput,
  setActivityModalLibraryDropdownTemplatesToDisplay,
  templates,
  templatesToDisplay,
  inputValue
) => {
  setActivityModalLibraryDropdownSearchInput(inputValue);

  if (templates?.length > 0) {
    const filteredTemplates = templates.filter(({ name }) => {
      return name.toLowerCase().includes(inputValue.toLowerCase());
    });
    setActivityModalLibraryDropdownTemplatesToDisplay(filteredTemplates);
  }
};

export const LibraryMenu = ({
  libraryDropdown,
  setActivityModalLibraryDropdownSearchInput,
  setActivityModalLibraryDropdownTemplatesToDisplay,
}) => {
  const { searchInput, templates, templatesToDisplay } = libraryDropdown;

  return (
    <div className="library_dropdown">
      <FormField
        className="library_dropdown__search_input"
        value={searchInput}
        name="searchInput"
        onChange={(value) => {
          handleTemplatesSearch(
            setActivityModalLibraryDropdownSearchInput,
            setActivityModalLibraryDropdownTemplatesToDisplay,
            templates,
            templatesToDisplay,
            value
          );
        }}
      />

      {renderMainContent(templatesToDisplay)}
    </div>
  );
};

const mapStateToProps = ({ activityModal }) => {
  const { libraryDropdown } = activityModal;

  return { libraryDropdown };
};

const mapDispatchToProps = (dispatch) => {
  const dispatchSetActivityModalLibraryDropdownSearchInput = (dispatch) => {
    return (searchInput) => {
      dispatch(setActivityModalLibraryDropdownSearchInput(searchInput));
    };
  };

  const dispatchSetActivityModalLibraryDropdownTemplatesToDisplay = (dispatch) => {
    return (templatesToDisplay) => {
      dispatch(setActivityModalLibraryDropdownTemplatesToDisplay(templatesToDisplay));
    };
  };

  return {
    setActivityModalLibraryDropdownSearchInput: dispatchSetActivityModalLibraryDropdownSearchInput(dispatch),
    setActivityModalLibraryDropdownTemplatesToDisplay:
      dispatchSetActivityModalLibraryDropdownTemplatesToDisplay(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LibraryMenu);
